import script from "./ParticleField.vue?vue&type=script&setup=true&lang=js"
export * from "./ParticleField.vue?vue&type=script&setup=true&lang=js"

import "./ParticleField.vue?vue&type=style&index=0&id=56e85b42&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56e85b42"]])

export default __exports__